/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Entity_IntegrationInputs */

const cs_enum_entity_integration = /** @type {(inputs: Enum_Entity_IntegrationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Integrace`)
};

const en_enum_entity_integration = /** @type {(inputs: Enum_Entity_IntegrationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Integration`)
};

/**
* | output |
* | --- |
* | "Integration" |
*
* @param {Enum_Entity_IntegrationInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_entity_integration = /** @type {((inputs?: Enum_Entity_IntegrationInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Entity_IntegrationInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_entity_integration(inputs)
	return cs_enum_entity_integration(inputs)
});